import { render } from "./SkeletonAccount.vue?vue&type=template&id=44df1d3e"
import script from "./SkeletonAccount.vue?vue&type=script&lang=js"
export * from "./SkeletonAccount.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__